module.exports = __webpack_public_path__ + "static/media/ic-close.295f7b14.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dublin-express/ic-close.svg
// module id = 114
// module chunks = 0